<div class="search-genre__wrapper">
  <div class="row">
    <form class="search-genre__forms" [formGroup]="SGenresForm" (ngSubmit)="onSubmitForm()" autocomplete="off">
      <div class="grid align-items-center">
        <div class="col-12 col-sm-12 no-padding">
          <div class="search-genre__forms-input">
            <div class="ui-input ui-input__text">
              <div class="ui-input__helper">
                <div class="ui-input__helper-icon">
                  <span class="mr-icon mr-icon-info"></span>
                </div>
              </div>
              <input placeholder="Введите Ваш жанр или стиль" type="text"
                validateHandler="textALL"
                formControlName="genre"
                pInputText
                tooltipStyleClass="p-tooltip__input"
                pTooltip="Название жанра можно вводить только на русском и английском языках"
                tooltipPosition="{{(deviceValue | async) === DTypes.Mobile ? 'bottom' : 'right'}}"
                hideDelay="0"
                tooltipEvent="focus"
                [tooltipDisabled]=STooltipDisabled
                (keyup)="onInputKeyup($event)">
            </div>
          </div>
        </div>
      </div>

      <div class="grid align-items-center flex-wrap pt-2 pb-2">
        <ng-container *ngFor="let genre of SGenresValue">
          <div class="col-auth mb-2 animated fast zoomIn">
            <p-chip label="{{genre.name}}" styleClass="activity__chip"
              [removable]="true"
              (onRemove)="onRemoveSelectedGenre(genre)">
            </p-chip>
          </div>
        </ng-container>

      </div>
    </form>
  </div>
  <div class="row">
    <div class="search-genre__results ui-scroll-vertical">
      <ng-container *ngFor="let genre of SResult;">
        <div class="search-genre__results-item">
          <div class="ui-checkbox w-full {{SGenresValue.length >= maxSelection && !genre.selected ? 'disabled' : ''}}">
            <input id="activity__{{genre.id}}" type="checkbox"
              [checked]="genre.selected"
              [disabled]="SGenresValue.length >= maxSelection && !genre.selected"
              (change)="onSetSelectedGenre(genre, $event)">

            <label for="activity__{{genre.id}}">
              <span class="ui-checkbox__text ellipsis-text">{{genre.name}}</span>
            </label>
          </div>
        </div>
      </ng-container>
      <div class="search-genre__results-empty" *ngIf="!SResult">
        <div class="grid align-items-center">
          <span class="mr-icon mr-icon-info"></span>
          <p class="ml-2">Мы не смогли найти жанр или стиль с таким названием.</p>
        </div>
        <div class="grid align-items-center">
          <a class="ml-6" (click)="onViewAllGenres($event)">Список всех жанров</a>
        </div>
      </div>


      <div class="search-genre__results-warning" *ngIf="SResult">
        <div class="grid align-items-center">
          <div class="col-auto mr-3">
            <span class="mr-icon mr-icon-status-error"></span>
          </div>
          <div class="col-7 col-sm-10">
            <p>Если в списке нет Вашего жанра,<br/> <strong>начните вводить</strong> его название в поле поиска</p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="search-genre__helpers">
      <div class="grid align-items-center"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">
        <div class="col-3 col-sm-12">
          <button class="ui-buttons ui-buttons__blue-large" (click)="onSubmitForm()">
            Применить
          </button>
        </div>
        <div class="col-8 col-sm-12"
          ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">
          <div class="grid align-items-center">
            <div class="col-auto mr-3">
              <span class="mr-icon mr-icon-info"></span>
            </div>
            <div class="col-8 col-sm-10">
              <p class="txt-caption__large">
                Выбрано <strong>{{ SGenresValue.length }} из {{ maxSelection }}</strong> жанров. Вы можете выбрать до <strong>{{ maxSelection }} музыкальных жанров или стилей</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="search-genre__helpers-graphic"
        *ngIf="(deviceValue | async) === DTypes.Desktop || (deviceValue | async) === DTypes.Tablet">
        <div class="ui-graphics__balalaika-dark"></div>
      </div>
    </div>
  </div>
</div>
